module.exports = __webpack_public_path__ + "img/calendar-check.118ab034.svg";